module.exports = __webpack_public_path__ + "img/about2.af14f86f.png";